<template>
    <div class="plus_card_div">
        <!--<FloatCard class="plus_card"-->
        <!--v-for="plus_info in all_plus"-->
        <!--:key="plus_info.id"-->
        <!--:data="plus_info"-->
        <!--&gt;-->
        <!--</FloatCard>-->
        <Card class="ujoy_plus_card"
              v-for="(data, index) in all_plus"
              :key="index"
              :data="data"
        >

        </Card>
    </div>
</template>
<script type="text/javascript">
    import plusApi from '@/api/plus/plus.js'

    import FloatCard from '@/components/common_components/cards/float_card.vue'
    import Card from '@/components/common_components/cards/lou_plus_card.vue'
    import {mapState} from 'vuex'

    export default {
        components: {
            Card,
            FloatCard,
        },
        data() {
            return {
                all_plus: []
            }
        },

        computed: {
            ...mapState({
                // path_information: state => state.path.path_information
            })
        },
        mounted() {
            plusApi.get_all_plus({}).then((res) => {
                this.all_plus = res.data
            })
        }
    }
</script>
<style type="text/css" scoped>
    .plus_card_div {
        display: flex;
        flex-wrap: wrap;
        width: 1170px;
        margin-left: auto;
        margin-right: auto;
    }

    .ujoy_plus_card {
        width: 25%;
        box-sizing: border-box;
        padding-right: 19px;
        padding-bottom: 19px;
    }

    .plus_card {
        width: 25%;
    }
</style>
